
import { Expenses } from "../entity/expenses-entity";
import { ExpensesDTO } from "./expenses-dto";

export class ExpensesAdapter{
    public convertDtoToEntity(expensesDTO: ExpensesDTO,  isUpdate: boolean = false ): Expenses {
        const expenses = new Expenses();
        expenses.expensesId=expensesDTO.expensesId
        expenses.expensesCategoryId=expensesDTO.expensesCategoryId;
        expenses.expensesAgainst=expensesDTO.expensesAgainst;
        expenses.refrenceNo=expensesDTO.refrenceNo;
        expenses.paidToEmployeeOrVendor=expensesDTO.paidToEmployeeOrVendor;
        expenses.employeeName=expensesDTO.employeeName;
        expenses.paymentMode=expensesDTO.paymentMode;
        expenses.paymentStatus=expensesDTO.paymentStatus;
        expenses.amount=expensesDTO.amount;
        expenses.approvedBy=expensesDTO.approvedBy;
        expenses.corpusApproval=expensesDTO.corpusApproval;
        expenses.remarks=expensesDTO.remarks;
        // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
        expenses.isActive=expensesDTO.isActive==undefined?true:expensesDTO.isActive;
        if (isUpdate) {
            expenses.updatedUser = expensesDTO.updatedUser;
        } else {
            expenses.isActive = true;
            expenses.createdUser = expensesDTO.createdUser;
        }
       return expenses;
      }
      public convertEntityToDto(expensesCategoryObject: Expenses): ExpensesDTO {
        const expensesCategoryDto= new ExpensesDTO;
        expensesCategoryDto.expensesId=expensesCategoryObject.expensesId
        expensesCategoryDto.expensesCategoryId=expensesCategoryObject.expensesCategoryId;
        expensesCategoryDto.expensesAgainst=expensesCategoryObject.expensesAgainst;
        expensesCategoryDto.refrenceNo=expensesCategoryObject.refrenceNo;
        expensesCategoryDto.paidToEmployeeOrVendor=expensesCategoryObject.paidToEmployeeOrVendor;
        expensesCategoryDto.employeeName=expensesCategoryObject.employeeName;
        expensesCategoryDto.paymentMode=expensesCategoryObject.paymentMode;
        expensesCategoryDto.paymentStatus=expensesCategoryObject.paymentStatus;
        expensesCategoryDto.amount=expensesCategoryObject.amount;
        expensesCategoryDto.approvedBy=expensesCategoryObject.approvedBy;
        expensesCategoryDto.corpusApproval=expensesCategoryObject.corpusApproval;
        expensesCategoryDto.remarks=expensesCategoryObject.remarks;
        expensesCategoryDto.isActive = expensesCategoryObject.isActive;
        expensesCategoryDto.createdAt = expensesCategoryObject.createdAt;
        expensesCategoryDto.updatedAt = expensesCategoryObject.updatedAt;
        expensesCategoryDto.createdUser = expensesCategoryObject.createdUser;
        expensesCategoryDto.updatedUser = expensesCategoryObject.updatedUser;
        expensesCategoryDto.versionFlag = expensesCategoryObject.versionFlag;
        return expensesCategoryDto;
      }
}